
export default {
  props: {
    user: {
      type: Object,
      required: true
    }
  }
}
